export default __webpack_public_path__ + "static/media/cmc.162bb9e7.png";